import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { api } from "../lib/api";

const CATEGORIES = [
    { value: "all", label: "All" },
    { value: "apparel", label: "Apparel" },
    { value: "footwear", label: "Footwear" },
    { value: "accessories", label: "Accessories" },
];

export default function Store() {
    const [products, setProducts] = useState([]);
    const [cat, setCat] = useState("all");

    useEffect(() => { api.get("/products").then((r) => setProducts(r.data)); }, []);

    const filtered = useMemo(
        () => (cat === "all" ? products : products.filter((p) => p.category === cat)),
        [products, cat],
    );

    return (
        <div data-testid="store-page" className="grain">
            <section className="border-b border-line py-16 md:py-24 bg-bg-soft">
                <div className="max-w-7xl mx-auto px-5 md:px-10">
                    <div className="text-gold text-xs tracking-[0.4em] uppercase font-bold mb-4 flex items-center gap-3">
                        <ShoppingBag size={14} /> Royal Store
                    </div>
                    <h1 className="h-display text-6xl md:text-8xl">Shop the Kingdom</h1>
                    <p className="text-ink text-lg mt-5 max-w-xl">Official Texas Kings gear. Built for the court. Worn off it.</p>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-5 md:px-10 py-12">
                <div className="flex flex-wrap gap-2 mb-8" data-testid="store-categories">
                    {CATEGORIES.map((c) => (
                        <button
                            key={c.value}
                            type="button"
                            onClick={() => setCat(c.value)}
                            data-testid={`cat-${c.value}`}
                            className={`px-4 py-2 text-[10px] tracking-[0.3em] uppercase font-bold border transition-colors ${
                                cat === c.value
                                    ? "border-gold bg-gold text-bg"
                                    : "border-line text-ink hover:border-gold hover:text-gold"
                            }`}
                        >
                            {c.label}
                        </button>
                    ))}
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {filtered.map((p) => (
                        <Link
                            key={p.id}
                            to={`/store/${p.slug}`}
                            data-testid={`product-${p.slug}`}
                            className="card-flat overflow-hidden group"
                        >
                            <div className="aspect-square bg-bg-soft relative overflow-hidden">
                                <div
                                    className="absolute inset-0 bg-contain bg-center bg-no-repeat transition-transform duration-700 group-hover:scale-105"
                                    style={{ backgroundImage: `url('${p.image_url}')` }}
                                />
                            </div>
                            <div className="p-5">
                                <div className="text-[10px] tracking-[0.3em] uppercase text-ink font-bold">{p.category}</div>
                                <div className="h-display text-xl mt-2">{p.name}</div>
                                <div className="text-gold text-lg mt-3 font-bold">${(p.price_cents / 100).toFixed(2)}</div>
                            </div>
                        </Link>
                    ))}
                </div>

                {filtered.length === 0 && <div className="text-center text-ink py-20">Nothing here yet.</div>}
            </section>
        </div>
    );
}
